import { FC } from "react";
import { Box, Typography } from "@mui/material";

const InvJobDetailsInfo: FC<any> = ({ data }) => {
  const details = [
    ["Job ID", data?.job_id],
    ["Contract", data?.contract_no],
    ["Inventory", data?.inventory_title],
    ["Status", data?.status],
    ["Customer", data?.customer],
    ["Crew Email", data?.crew_email],
    ["Origin", data?.origin],
    ["Destination", data?.destination],
    ["Date", data?.date],
    ["Tags", data?.tag],
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#E5F4F1",
        borderRadius: "5px",
        padding: "10px 16px",
        fontSize: "13px",
        color: "#555",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1,
      }}
    >
      {details.map(([label, value], index) => (
        <Typography
          key={label}
          component="span"
          sx={{ fontSize: "13px", overflowWrap: "anywhere" }}
        >
          {label}: <b>{value || "—"}</b>
          {index < details.length - 1 && (
            <Box component="span" sx={{ color: "#BBB", ml: 1 }}>
              •
            </Box>
          )}
        </Typography>
      ))}
    </Box>
  );
};

export default InvJobDetailsInfo;
